import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LineItem from "./_LineItem";
import "../Styles/_LineItemsInformation.css";
import { orderUtils } from "../Helpers/OderUtils";
import { Divider } from "@material-ui/core";

class LineItemsInformation extends Component {
    getTableHeaderLabel(currentLanguage) {
        if (this.props.cancelled) {
            return currentLanguage.ORDER_PAGE.ITEMS_SECTION.CANCELLED.TITLE;
        }
        if (this.props.refunded) {
            return currentLanguage.ORDER_PAGE.ITEMS_SECTION.REFUNDED.TITLE;
        }
        return currentLanguage.ORDER_PAGE.ITEMS_SECTION.ORDERED_ITEMS.TITLE;
    }

    adjustQuantities(items, refundedItems, refunded) {
        return items
            .map(item => {
                const refundedItem = refundedItems.find(refItem => refItem.id === item.id);
                if (refundedItem) {
                    if (refunded) {
                        return { ...item, quantity: refundedItem.quantity };
                    } else {
                        return { ...item, quantity: item.quantity - refundedItem.quantity };
                    }
                }
                return refunded ? null : item;
            })
            .filter(item => item && item.quantity > 0);
    }

    render() {
        let order = this.props.order;
        let currentLanguage = this.props.currentLanguage;
        let protectionItems = orderUtils.getProtectionItems(this.props.order);
        let egiftcardItems = this.props.order.egift_cards;
        let normalItems = orderUtils.getItemsThatRequireShipping(this.props.order);
        let refundedItems = this.props.refundedItems;
        let refunded = this.props.refunded;

        normalItems = this.adjustQuantities(normalItems, refundedItems, refunded);
        protectionItems = this.adjustQuantities(protectionItems, refundedItems, refunded);
        egiftcardItems = this.adjustQuantities(egiftcardItems, refundedItems, refunded);

        if (normalItems.length === 0 && egiftcardItems.length === 0 && protectionItems.length === 0) {
            return false;
        }

        if (refunded && refundedItems.length === 0) {
            return false;
        }

        return (
            <div className="line-items-container allow-focus" tabIndex="0">
                <div className="line-items-header">
                    <div className="line-items-column-1">
                        <h2 style={{ margin: "0px" }}>{this.getTableHeaderLabel(currentLanguage)}</h2>
                    </div>
                    <div className="line-items-column-2">{currentLanguage.ORDER_PAGE.ITEMS_SECTION.HEADER.QUANTITY}</div>
                    <div className="line-items-column-3">{currentLanguage.ORDER_PAGE.ITEMS_SECTION.HEADER.TOTAL}</div>
                </div>
                <div className="flex layout vertical line-items-list">
                    {normalItems.map((_item, index) => (
                        <LineItem item={_item} key={index} order={order} />
                    ))}
                    {protectionItems.length > 0 && (
                        <React.Fragment>
                            <div className="line-items-divider">
                                <h3 className="line-items-list-sub-title">{currentLanguage.ORDER_PAGE.ITEMS_SECTION.PROTECTION.TITLE}</h3>
                            </div>
                            {protectionItems.map((_item, index) => (
                                <LineItem item={_item} key={index} order={order} />
                            ))}
                        </React.Fragment>
                    )}
                    {egiftcardItems.length > 0 && (
                        <React.Fragment>
                            <div className="line-items-divider">
                                <h3 className="line-items-list-sub-title">{currentLanguage.ORDER_PAGE.ITEMS_SECTION.EGIFTCARDS.TITLE}</h3>
                                {this.props.ordered && (
                                    <button
                                        type="button"
                                        className="allow-focus order-line-items-button"
                                        onClick={() => this.props.egiftcardsOpen("SEND_EGIFTCARDS_EMAIL", true)}
                                    >
                                        {currentLanguage.ORDER_PAGE.MENU.SEND_EGIFTCARDS_EMAIL}
                                    </button>
                                )}
                            </div>
                            {egiftcardItems.map((_item, index) => (
                                <LineItem item={_item} key={index} order={order} egiftcard />
                            ))}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(LineItemsInformation);



// WEBPACK FOOTER //
// ./src/views/Order/components/_LineItemsInformation.jsx